import { HTMLSelect, InputGroup } from '@blueprintjs/core'
import * as React from 'react'
import USAStates from '../../../../../constants/USAStates'
import { UsaStateInfo } from './types'
import { resolveStateValue } from './utils'

interface Props {
  country: string
  value?: string
  fill?: any
  onChange: (e: any) => void
  disabled?: boolean
  color?: string
  style?: React.CSSProperties
}

const Options = USAStates.map((s: UsaStateInfo) => {
  return (
    <option key={s.abbreviation} value={s.abbreviation.toUpperCase()}>
      {s.name}
    </option>
  )
})

/**
 * TolerantUsaStateSelect will render a dropdown of us states and territories if the country is the US
 * If the country is not the US, it will render a input
 * Maps the options instead of the HTMLSelect option to provide a custom key for react
 */
export const TolerantUsaStateSelect: React.FC<Props> = props => {
  if (props.country === 'US' || props.country === 'United States' || !props.country) {
    return (
      <HTMLSelect {...props} value={resolveStateValue(props.value)}>
        <option value={null}>Choose a state...</option>
        {Options}
      </HTMLSelect>
    )
  }

  return <InputGroup {...props} value={props.value} />
}
